import { useContext, useState } from 'react';
import { TimesheetsDayEntryPopup } from '../TimesheetsDayEntryPopup';
import {
  HourPill,
  Status,
  SuccessOverlay,
  TableRowBodyCell,
  TableRowCellText,
  TimeOffDayEntry,
  UnavaliableDayEntry,
} from './styles/TimesheetsTableBodyCell.styled';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { TimeTrackingAssignment } from 'src/tabs/models/TimesheetsInterface';
import moment from 'moment';

interface TimeSheetsTableBodyCellProps {
  assignmentId?: string;
  timeTrackingId?: string;
  description?: string;
  date?: string;
  hours?: number;
  forecastedHours?: number;
  showHourPills?: boolean;
  index?: number;
  title?: string;
  weeklyHours?: number;
  assignmentType?: number;
  statecode?: number;
  status?: number;
  getAssignments?: () => void;
  dayType?: number;
  anyPopupsOpen?: boolean;
  setAnyPopupsOpen?: (value: boolean) => void;
  assignment?: TimeTrackingAssignment
}

export const TimeSheetsTableBodyCell = ({
  assignmentId,
  timeTrackingId,
  description,
  hours,
  index,
  title,
  date,
  weeklyHours,
  forecastedHours,
  showHourPills,
  assignmentType,
  statecode,
  status,
  getAssignments,
  dayType,
  anyPopupsOpen,
  setAnyPopupsOpen,
  assignment
}: TimeSheetsTableBodyCellProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  const [isCalloutVisible, setIsCalloutVisible] = useState<boolean>(false);
  const [showSuccessOverlay, setShowSuccessOverlay] = useState<boolean>(false);
  const isCompleted = hours >= forecastedHours;
  const isTimeOffEntry = assignmentType === 100000004;
  const entryDate = moment(date);
  const isValidDate = entryDate >= moment(assignment?.new_startdate) && entryDate <= moment(assignment?.new_enddate);
  const unAvaliableEntry =
    (forecastedHours === undefined && assignmentType <= 100000001) ||
    isTimeOffEntry || (date && !isValidDate);
  const isWorkday = dayType === 100000000;
  const isDisabled = statecode && statecode !== 0;

  const toggleOnIsCalloutVisible = () => {
    if (anyPopupsOpen) {
      if (isCalloutVisible) {
        setIsCalloutVisible(false);
        setAnyPopupsOpen(false);
        return;
      }
      return;
    }
    setAnyPopupsOpen(true);
    setIsCalloutVisible(true);
  };

  return (
    <TableRowBodyCell
      vertical-align="middle"
      firstRow={title !== undefined}
      lastRow={index === 7}
      unAvailableEntry={unAvaliableEntry}
      isCalloutVisible={isCalloutVisible}
      isWorkday={isWorkday}
      isMobile={isMobile}
    >
      {unAvaliableEntry ? (
        <>
          {isTimeOffEntry ? (
            <>
              <TimeOffDayEntry>{hours || null}</TimeOffDayEntry>
            </>
          ) : (
            <UnavaliableDayEntry />
          )}
        </>
      ) : (
        <>
          {showSuccessOverlay && <SuccessOverlay className="successOverlay" />}
          {assignmentType === 100000000 && !hours && showHourPills ? (
            <TableRowCellText>0</TableRowCellText>
          ) : (
            <TableRowCellText>{title || hours || weeklyHours}</TableRowCellText>
          )}

          <HourPill showHourPills={showHourPills}>
            <Status isCompleted={isCompleted} isDisabled={isDisabled} />
            {hours || 0}/{forecastedHours}
          </HourPill>
          <TimesheetsDayEntryPopup
            setAnyPopupsOpen={setAnyPopupsOpen}
            hours={hours}
            date={date}
            description={description}
            assignmentId={assignmentId}
            timeTrackingId={timeTrackingId}
            forecastSupply={forecastedHours}
            setShowSuccessOverlay={setShowSuccessOverlay}
            isCalloutVisible={isCalloutVisible}
            toggleOnIsCalloutVisible={toggleOnIsCalloutVisible}
            statecode={statecode}
            isDisabled={isDisabled}
            status={status}
            getAssignments={getAssignments}
            setIsCalloutVisible={setIsCalloutVisible}
          />
        </>
      )}
    </TableRowBodyCell>
  );
};
